import { createContext } from "react";

const ExerciseStateContext = createContext({
  exerciseState: "",
  setExerciseState: () => {},
});

export default ExerciseStateContext;
